<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <div class="n-fulek">
    <button *ngFor="let f of fulek" type="button" [class.aktiv]="nezet === f.k" (click)="fulValt(f.k)">{{ f.c }}</button>
  </div>

  <!-- ÁFA -->
  <div *ngIf="nezet === 'afa' && afa">
    <div class="osszeg-sav">
      <div class="item">Fizetendő ÁFA: <b>{{ afa.egyenleg.fizetendo | number:'1.0-0' }} Ft</b></div>
      <div class="item">Levonható ÁFA: <b>{{ afa.egyenleg.levonhato | number:'1.0-0' }} Ft</b></div>
      <div class="item">Különbözet: <b>{{ afa.egyenleg.kulonbozet | number:'1.0-0' }} Ft</b></div>
    </div>
    <h3 style="margin:12px 16px 4px; color:var(--naplo)">ÁFA összesítés kulcsonként</h3>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th>Irány</th><th class="num">ÁFA %</th><th class="num">Nettó</th><th class="num">ÁFA</th><th class="num">Bruttó</th></tr></thead>
        <tbody>
          <tr *ngFor="let o of afa.osszesites">
            <td>{{ o.irany === 'bevetel' ? 'Fizetendő (bevétel)' : 'Levonható (kiadás)' }}</td>
            <td class="num">{{ o.afa_kulcs }}%</td>
            <td class="num">{{ o.netto | number:'1.0-0' }}</td><td class="num">{{ o.afa | number:'1.0-0' }}</td><td class="num">{{ o.brutto | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <h3 style="margin:12px 16px 4px; color:var(--naplo)">ÁFA tételes lista</h3>
    <div class="tabla-wrap">
      <table class="naplo-tabla">
        <thead><tr><th>#</th><th>Dátum</th><th>ÁFA esed.</th><th>Bizonylat</th><th>Partner</th><th>Rovat</th><th>Irány</th><th class="num">%</th><th class="num">Nettó</th><th class="num">ÁFA</th><th class="num">Bruttó</th></tr></thead>
        <tbody>
          <tr *ngFor="let r of afa.lista">
            <td>{{ r.sorszam }}</td><td>{{ r.datum }}</td><td>{{ r.afa_esedekesseg }}</td><td>{{ r.bizonylatszam }}</td><td>{{ r.partner_nev }}</td>
            <td>{{ r.rovatszam }}</td><td>{{ r.irany === 'bevetel' ? 'Bev.' : 'Kiad.' }}</td>
            <td class="num">{{ r.afa_kulcs }}</td><td class="num">{{ r.netto | number:'1.0-0' }}</td><td class="num">{{ r.afa | number:'1.0-0' }}</td><td class="num">{{ r.brutto | number:'1.0-0' }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- EREDMÉNY -->
  <div *ngIf="nezet === 'eredmeny' && eredmeny" class="tabla-wrap">
    <table class="naplo-tabla">
      <thead><tr><th>Hónap</th><th class="num">Bevétel</th><th class="num">Kiadás</th><th class="num">Havi eredmény</th><th class="num">Göngyölt</th></tr></thead>
      <tbody>
        <tr *ngFor="let h of eredmeny.lista">
          <td>{{ honapok[h.ho - 1] }}</td>
          <td class="num">{{ h.bevetel | number:'1.0-0' }}</td><td class="num">{{ h.kiadas | number:'1.0-0' }}</td>
          <td class="num">{{ h.eredmeny | number:'1.0-0' }}</td><td class="num">{{ h.gongyolt | number:'1.0-0' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- PÉNZFORGALOM -->
  <div *ngIf="nezet === 'penzforgalom' && penzforgalom">
    <div *ngFor="let p of penzforgalom.penztarak">
      <div class="naplo-eszkozsor" style="font-weight:600; color:var(--naplo)">
        {{ p.penztar.azonosito }} – {{ p.penztar.nev }} ({{ p.penztar.tipus }}) · Nyitó: {{ p.nyito | number:'1.0-0' }} Ft · Záró: <b>{{ p.zaro | number:'1.0-0' }} Ft</b>
      </div>
      <div class="tabla-wrap" *ngIf="p.sorok.length">
        <table class="naplo-tabla">
          <thead><tr><th>#</th><th>Dátum</th><th>Bizonylat</th><th>Partner</th><th>Megjegyzés</th><th class="num">Bevétel</th><th class="num">Kiadás</th><th class="num">Egyenleg</th></tr></thead>
          <tbody>
            <tr *ngFor="let s of p.sorok">
              <td>{{ s.sorszam }}</td><td>{{ s.datum }}</td><td>{{ s.bizonylatszam }}</td><td>{{ s.partner_nev }}</td><td>{{ s.megjegyzes }}</td>
              <td class="num">{{ s.bevetel ? (s.bevetel | number:'1.0-0') : '' }}</td><td class="num">{{ s.kiadas ? (s.kiadas | number:'1.0-0') : '' }}</td>
              <td class="num">{{ s.egyenleg | number:'1.0-0' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- ROVATANALITIKA -->
  <div *ngIf="nezet === 'rovat'" class="tabla-wrap">
    <table class="naplo-tabla">
      <thead><tr><th>Rovat</th><th class="num">Oszlop</th><th>Irány</th><th class="num">Db</th><th class="num">Nettó</th><th class="num">ÁFA</th><th class="num">Bruttó</th></tr></thead>
      <tbody>
        <tr *ngFor="let r of rovat">
          <td>{{ r.rovatszam }}</td><td class="num">{{ r.oszlop }}</td><td>{{ r.irany === 'bevetel' ? 'Bevétel' : 'Kiadás' }}</td>
          <td class="num">{{ r.db }}</td><td class="num">{{ r.netto | number:'1.0-0' }}</td><td class="num">{{ r.afa | number:'1.0-0' }}</td><td class="num">{{ r.brutto | number:'1.0-0' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- PARTNERÖSSZESÍTŐ -->
  <div *ngIf="nezet === 'partner'" class="tabla-wrap">
    <table class="naplo-tabla">
      <thead><tr><th>Partner</th><th class="num">Tételek</th><th class="num">Bevétel</th><th class="num">Kiadás</th>
        <th class="kp-fej" title="Az Art. 114. §-a szerint a pénzforgalmi számlanyitásra kötelezett adózók között szerződésenként és havonta legfeljebb 1,5 millió Ft fizethető készpénzben (áfával együtt). A sáv a partnernél a legnagyobb havi készpénzes kifizetést mutatja.">
          Készpénz / hó (1,5 M Ft)</th></tr></thead>
      <tbody>
        <tr *ngFor="let p of partner">
          <td>{{ p.partner }}</td><td class="num">{{ p.tetelek }}</td><td class="num">{{ p.bevetel | number:'1.0-0' }}</td><td class="num">{{ p.kiadas | number:'1.0-0' }}</td>
          <td class="kp-cella">
            <ng-container *ngIf="p.kp_max">
              <div class="kp-sav" [title]="'Legnagyobb havi készpénzes kifizetés: ' + (p.kp_max | number:'1.0-0') + ' Ft (' + honapNev(p.kp_max_ho) + '), éves készpénz: ' + (p.kp_ossz | number:'1.0-0') + ' Ft'">
                <span [style.width.%]="kpSzazalek(p)" [class.tullepes]="p.kp_max > p.kp_korlat"></span>
              </div>
              <small [class.tullepes-szoveg]="p.kp_max > p.kp_korlat">
                {{ p.kp_max | number:'1.0-0' }} Ft · {{ honapNev(p.kp_max_ho) }}
                <b *ngIf="p.kp_max > p.kp_korlat">– túllépés!</b>
              </small>
            </ng-container>
            <small class="halvany" *ngIf="!p.kp_max">—</small>
          </td>
        </tr>
      </tbody>
    </table>
    <p class="halvany" style="margin:6px 2px 0;font-size:12px">
      A készpénz-sáv a <b>havi</b> készpénzes kifizetést méri a partner felé (Art. 114. §: szerződésenként és havonta
      1,5 millió Ft, áfával; a fölötte lévő rész után mindkét félre 20% mulasztási bírság szabható ki). Szerződésenkénti
      bontás nincs, ezért partnerenként és hónaponként összesítünk – a szerződéses bontást a könyvelő ítéli meg.
    </p>
  </div>
</ng-container>
